import { ONBOARDING_V2_STEPS, type OnboardingV2Step } from "@graftus/schema";

/**
 * The six-step onboarding (GRA-171): account, sector, organisation,
 * employees, teams, invite. Shared with the server draft in `@graftus/schema`.
 */
export const ONBOARDING_STEPS = ONBOARDING_V2_STEPS;
export type OnboardingStepKey = OnboardingV2Step;

/** Everything the `/onboarding` route can show: the welcome, a step, or the done screen. */
export const ONBOARDING_SCREENS = [
  "welcome",
  ...ONBOARDING_STEPS,
  "done",
] as const;
export type OnboardingScreen = (typeof ONBOARDING_SCREENS)[number];

export function isOnboardingScreen(value: unknown): value is OnboardingScreen {
  return (
    typeof value === "string" &&
    (ONBOARDING_SCREENS as readonly string[]).includes(value)
  );
}

export function isOnboardingStep(value: unknown): value is OnboardingStepKey {
  return (
    typeof value === "string" &&
    (ONBOARDING_STEPS as readonly string[]).includes(value)
  );
}

/** Position in the whole sequence: welcome 0, steps 1..6, done 7. */
export function screenIndex(screen: OnboardingScreen): number {
  return ONBOARDING_SCREENS.indexOf(screen);
}

/** Position among the six steps: -1 for the welcome, 0..5, 6 for done. */
export function stepIndex(screen: OnboardingScreen): number {
  return screenIndex(screen) - 1;
}
